import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast, Toaster } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6" data-testid="admin-login-page">
      <Toaster richColors position="top-center"/>
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <img src="https://customer-assets.emergentagent.com/job_yuva-modern/artifacts/d1s5jglr_Untitled_design__1_-removebg-preview.png" alt="Yuva Ayurvedic Clinic Private Limited" className="w-20 h-20 object-contain mx-auto"/>
          <h1 className="font-serif-display text-4xl mt-6">Admin</h1>
          <p className="text-sm text-muted-foreground mt-2">Sign in to manage the clinic.</p>
        </div>
        <form onSubmit={submit} className="bg-ivory border border-border/50 rounded-2xl p-8 space-y-5" data-testid="admin-login-form">
          <div><Label>Email</Label><Input data-testid="admin-email" type="email" value={form.email} onChange={set("email")} className="bg-cream h-12 mt-2" required/></div>
          <div><Label>Password</Label><Input data-testid="admin-password" type="password" value={form.password} onChange={set("password")} className="bg-cream h-12 mt-2" required/></div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full rounded-full bg-forest text-cream py-3 hover:bg-terracotta transition-all duration-500 disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
